<template>
  <!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 1.1//EN" "http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd">
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 2376 2622"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    xml:space="preserve"
    xmlns:serif="http://www.serif.com/"
    style="
      fill-rule: evenodd;
      clip-rule: evenodd;
      stroke-linejoin: round;
      stroke-miterlimit: 2;
    "
  >
    <g transform="matrix(0.999587,0,0,0.999587,4.02998,1.08518)">
      <g id="singlet_6_back">
        <g
          id="gradient-colour"
          transform="matrix(15.0901,0,0,15.0901,1880.43,407.067)"
        >
          <path
            d="M0,119.745C0.125,116.735 1.234,113.743 1.475,109.698C1.35,102.492 0.121,95.285 1.1,88.079C1.429,85.724 1.791,83.399 -0.564,81.253C-0.783,78.322 -0.621,74.928 0.192,71.394C1.592,58.529 1.033,45.281 1.16,32.167C1.454,30.973 1.748,29.779 2.042,28.585C-2.95,27.372 -6.638,24.312 -8.109,15.544C-9.318,2.704 -9.704,-10.404 -7.258,-24.431C-11.826,-25.198 -16.394,-25.966 -20.962,-26.733C-25.951,-15.707 -33.98,-9.295 -46.124,-9.127C-58.269,-9.295 -66.298,-15.707 -71.287,-26.733C-75.855,-25.966 -80.423,-25.198 -84.991,-24.431C-82.545,-10.404 -82.931,2.704 -84.14,15.544C-85.611,24.312 -89.299,27.372 -94.291,28.585C-93.997,29.779 -93.703,30.973 -93.409,32.167C-93.281,45.281 -93.841,58.529 -92.441,71.394C-91.628,74.928 -91.466,78.322 -91.685,81.253C-94.04,83.399 -93.678,85.724 -93.349,88.079C-92.37,95.285 -93.599,102.492 -93.724,109.698C-93.483,113.743 -92.374,116.735 -92.249,119.745C-91.982,126.17 -93.287,131.547 -95.534,139.04C-92.198,139.074 -88.863,139.109 -85.528,139.144C-72.254,144.674 -62.473,146.009 -46.124,146.478C-29.776,146.009 -19.995,144.674 -6.721,139.144C-3.386,139.109 -0.05,139.074 3.285,139.04C1.038,131.547 -0.267,126.17 0,119.745"
            :style="{ fill: `url(#linear${id})` }"
          />
        </g>
        <g
          id="outline"
          transform="matrix(15.0901,0,0,15.0901,-15527.3,-10966.1)"
        >
          <path
            d="M1155.48,784.997C1155.35,785.536 1155.25,785.935 1155.25,785.935C1155.12,799.048 1155.68,812.294 1154.28,825.157L1154.28,825.172L1154.28,825.186C1153.48,828.654 1153.31,831.986 1153.52,834.872C1155.87,837.07 1155.53,839.442 1155.19,841.849C1154.21,849.043 1155.44,856.237 1155.57,863.43L1155.57,863.44L1155.57,863.449C1155.33,867.492 1154.22,870.483 1154.09,873.492C1153.83,879.89 1155.13,885.243 1157.37,892.705L1157.46,893.023L1157.13,893.026C1153.81,893.06 1150.49,893.095 1147.17,893.13C1133.89,898.657 1124.09,899.995 1107.72,900.464L1107.72,900.465L1107.71,900.464C1091.34,899.995 1081.54,898.657 1068.26,893.13C1064.94,893.095 1061.62,893.06 1058.3,893.026L1057.97,893.023L1058.07,892.705C1060.31,885.243 1061.61,879.89 1061.34,873.492C1061.22,870.483 1060.11,867.492 1059.87,863.449L1059.87,863.44L1059.87,863.43C1059.99,856.237 1061.22,849.043 1060.24,841.849C1059.91,839.442 1059.56,837.07 1061.91,834.872C1062.12,831.986 1061.95,828.654 1061.16,825.186L1061.15,825.172L1061.15,825.157C1059.75,812.294 1060.31,799.048 1060.18,785.935L1059.95,784.997L1059.25,782.137L1059.49,782.078C1064.4,780.886 1068.01,777.864 1069.45,769.248C1070.66,756.432 1071.05,743.348 1068.6,729.348L1068.56,729.1L1068.81,729.059C1069.69,728.91 1070.58,728.761 1071.46,728.612C1074.21,728.151 1076.95,727.691 1079.7,727.23C1080.64,727.072 1081.57,726.915 1082.51,726.757L1082.7,726.725L1082.78,726.901C1087.73,737.829 1095.68,744.192 1107.72,744.359C1119.75,744.192 1127.71,737.829 1132.65,726.901L1132.73,726.725L1132.92,726.757C1133.74,726.895 1134.57,727.033 1135.39,727.171C1138.25,727.652 1141.11,728.132 1143.97,728.612C1144.85,728.761 1145.74,728.91 1146.62,729.059L1146.87,729.1L1146.83,729.348C1144.39,743.348 1144.77,756.432 1145.98,769.251C1147.43,777.865 1151.04,780.886 1155.94,782.078L1156.19,782.137L1155.48,784.997ZM1060.44,784.877L1060.68,785.872L1060.68,785.901C1060.81,799.002 1060.25,812.237 1061.65,825.084C1062.46,828.641 1062.63,832.057 1062.4,835.008L1062.4,835.107L1062.32,835.174C1060.05,837.249 1060.42,839.504 1060.74,841.782C1061.72,848.997 1060.49,856.214 1060.37,863.433C1060.61,867.473 1061.72,870.463 1061.84,873.471C1062.11,879.832 1060.84,885.17 1058.64,892.53C1061.87,892.563 1065.09,892.597 1068.32,892.63L1068.36,892.631L1068.41,892.65C1081.65,898.166 1091.41,899.496 1107.72,899.964C1124.02,899.496 1133.78,898.166 1147.02,892.65L1147.07,892.631L1147.12,892.63C1150.34,892.597 1153.57,892.563 1156.79,892.53C1154.59,885.17 1153.33,879.832 1153.59,873.471C1153.72,870.462 1154.82,867.471 1155.07,863.425C1154.94,856.211 1153.71,848.995 1154.69,841.781C1155.01,839.504 1155.39,837.249 1153.11,835.174L1153.04,835.107L1153.03,835.008C1152.81,832.059 1152.97,828.644 1153.79,825.088C1155.18,812.236 1154.62,799.001 1154.75,785.901L1154.75,785.872L1155,784.877C1147.36,782.917 1144.34,777.243 1143.07,769.726L1143.06,769.64C1143.06,769.633 1143.06,769.626 1143.06,769.619L1143.05,769.535L1143.3,769.76L1143.05,769.533C1141.77,755.896 1141.55,742.652 1143.88,729.105C1141.09,728.635 1138.29,728.165 1135.49,727.695L1135.47,727.798C1135.46,727.821 1135.46,727.842 1135.45,727.86L1135.34,728.11C1135.34,728.111 1135.33,728.113 1135.33,728.115C1129.96,739.985 1121.07,747.119 1107.75,747.304L1107.68,747.304C1094.36,747.119 1085.47,739.985 1080.1,728.115L1079.91,727.701C1077.12,728.169 1074.34,728.637 1071.55,729.105C1073.88,742.652 1073.67,755.896 1072.38,769.533L1072.13,769.76L1072.38,769.538L1072.38,769.621C1072.37,769.628 1072.37,769.634 1072.37,769.64L1072.36,769.726C1071.1,777.243 1068.07,782.918 1060.44,784.877ZM1071.06,729.188L1069.14,729.51C1071.54,743.467 1071.15,756.518 1069.95,769.304L1069.95,769.313L1069.95,769.322C1068.48,778.092 1064.8,781.231 1059.85,782.503L1060.32,784.392C1067.73,782.485 1070.64,776.946 1071.87,769.643L1071.88,769.57L1071.88,769.561L1071.89,769.487C1073.17,755.893 1073.38,742.691 1071.06,729.188ZM1135,727.613C1134.36,727.506 1133.36,727.337 1133.03,727.282C1127.99,738.296 1119.91,744.691 1107.72,744.859L1107.71,744.859C1095.53,744.691 1087.44,738.296 1082.41,727.282L1080.42,727.615L1080.55,727.909C1085.84,739.589 1094.58,746.623 1107.69,746.805C1107.69,746.804 1107.7,746.804 1107.7,746.804C1107.71,746.804 1107.72,746.804 1107.73,746.805C1107.73,746.804 1107.74,746.804 1107.74,746.804L1107.75,746.804C1120.85,746.622 1129.59,739.589 1134.88,727.909L1134.98,727.68L1135,727.613ZM1155.12,784.391L1155.58,782.503C1150.63,781.231 1146.96,778.092 1145.49,769.322L1145.48,769.313L1145.48,769.304C1144.28,756.518 1143.89,743.467 1146.29,729.51L1144.38,729.188C1142.05,742.691 1142.27,755.893 1143.55,769.486L1143.55,769.561L1143.56,769.573L1143.57,769.643C1144.79,776.946 1147.7,782.485 1155.12,784.391Z"
            style="fill: #6f7271"
          />
        </g>
        <rect
          id="logo-mask-1"
          x="716.231"
          y="589.85"
          width="946.655"
          height="1014.17"
          style="fill: none"
        />
        <use
          id="full-back-logo"
          :xlink:href="`#backFull${id}`"
          x="400"
          y="330"
          width="460px"
          height="514px"
          transform="matrix(1.71038,0,0,1.71038,503.522,577.002)"
        />
        <rect
          id="logo-mask-2"
          x="713.936"
          y="679.36"
          width="948.128"
          height="440.115"
          style="fill: none"
        />
        <use
          id="back-centre-logo"
          :xlink:href="`#backCenter${id}`"
          x="3740"
          y="3800"
          width="943px"
          height="306px"
          transform="matrix(1,0,0,1,-2558.56,-2895.51)"
        />
        <rect
          id="logo-mask-3"
          x="1074.65"
          y="264.884"
          width="236.764"
          height="124.687"
          style="fill: none"
        />
        <clipPath id="_clip3">
          <rect x="750" y="200" width="800" height="800" />
        </clipPath>
        <g clip-path="url(#_clip3)">
          <use
            id="under-back-logo"
            :xlink:href="`#backUpper${id}`"
            x="1550"
            y="1050"
            width="300px"
            height="136px"
            transform="matrix(0.794512,0,0,0.794512,-47.2027,-287.969)"
          />
        </g>
        <g
          v-if="activePlayer"
          id="number-mask"
          transform="matrix(1.00041,0,0,1.00041,-2.14287,364.032)"
        >
          <path
            d="M473.701,791.767l1425.32,-5.738l-25.714,483.861l34.303,56.927c-21.701,131.802 3.505,333.405 -1.894,359.205c-29.512,141.026 -33.472,240.808 26.13,453.177l-153.393,2.949c-278.233,133.459 -781.3,163.888 -1184.01,2.62c-7.34,-2.939 -76.255,-0.498 -152.011,-0.471c30.432,-96.209 53.505,-192.23 55.777,-287.715l-26.175,-143.517c10.407,-138.272 21.19,-260.006 -1.689,-384.097l30.575,-65.764l-27.217,-471.437Z"
            style="fill: none"
          />
          <clipPath id="_clip2">
            <path
              d="M473.701,791.767l1425.32,-5.738l-25.714,483.861l34.303,56.927c-21.701,131.802 3.505,333.405 -1.894,359.205c-29.512,141.026 -33.472,240.808 26.13,453.177l-153.393,2.949c-278.233,133.459 -781.3,163.888 -1184.01,2.62c-7.34,-2.939 -76.255,-0.498 -152.011,-0.471c30.432,-96.209 53.505,-192.23 55.777,-287.715l-26.175,-143.517c10.407,-138.272 21.19,-260.006 -1.689,-384.097l30.575,-65.764l-27.217,-471.437Z"
            />
          </clipPath>
          <g clip-path="url(#_clip2)">
            <g
              id="player-number"
              serif:id="player number"
              transform="matrix(0.997277,0,0,0.997277,569.2,1454.36)"
            >
              <BackPlayerNumber
                :activePlayer="activePlayer"
                :details="details"
              />
            </g>
          </g>
        </g>
        <g
          v-if="activePlayer"
          id="player-mask"
          transform="matrix(1.00041,0,0,1.00041,-2.14287,364.032)"
        >
          <path
            d="M1903.5,517.329c-193.397,-53.37 -227.113,-252.929 -169.472,-845.59l-126.745,-20.407c-83.023,187.723 -221.016,289.228 -423.133,290.157c-175.858,-3.147 -319.992,-69.583 -414.057,-291.477l-133.153,22.36c49.991,426.01 72.689,800.826 -164.083,840.549l7.413,332.36l1415.53,-3.178l7.699,-324.774Z"
            style="fill: none"
          />
          <clipPath id="_clip4">
            <path
              d="M1903.5,517.329c-193.397,-53.37 -227.113,-252.929 -169.472,-845.59l-126.745,-20.407c-83.023,187.723 -221.016,289.228 -423.133,290.157c-175.858,-3.147 -319.992,-69.583 -414.057,-291.477l-133.153,22.36c49.991,426.01 72.689,800.826 -164.083,840.549l7.413,332.36l1415.53,-3.178l7.699,-324.774Z"
            />
          </clipPath>
          <g clip-path="url(#_clip4)">
            <g
              id="player-name"
              serif:id="player name"
              transform="matrix(0.997277,0,0,0.997277,780.994,738.7)"
            >
              <text
                text-anchor="middle"
                x="400"
                :y="`${activePlayer.nameBackVerticalPosition * 6.5 - 550}`"
                :style="{
                  fontFamily: details.fontFamily,
                  fontSize: `${activePlayer.nameSize * 10}`,
                  fill: details.fontColor.value,
                  zIndex: 1000,
                }"
              >
                {{ activePlayer.name }}
              </text>
            </g>
          </g>
        </g>
        <g
          id="cheeta-logo"
          v-if="cheetaLogo.position === 'back'"
          transform="matrix(3.14809,0,0,3.0699,1053.68,341.673)"
        >
          <path
            d="M11.062,7.23l0.679,-2.689l-3.915,0l-0.678,2.689l-1.072,4.252l-0.678,2.687l3.916,-0l0.677,-2.687l4.769,0l-1.113,4.413c-0.375,1.485 -1.71,2.526 -3.242,2.526l-6.555,0c-2.178,0 -3.775,-2.049 -3.242,-4.16l2.886,-11.446c0.374,-1.485 1.71,-2.525 3.241,-2.525l6.557,0c2.178,0 3.774,2.049 3.242,4.161l-0.701,2.78l-4.771,-0.001Zm16.353,-6.745l4.768,0l-2.205,8.551l-0.617,2.446l-1.749,6.94l-4.77,0l1.751,-6.94l-3.916,0l-1.75,6.941l-4.769,0l4.572,-17.938l4.769,0l-1.75,6.745l3.915,0l1.751,-6.745Zm9.614,4.056l-0.678,2.689l6.766,0l-1.072,4.252l-6.766,0l-0.679,2.687l6.766,-0l-1.072,4.253l-11.533,-0l4.571,-17.937l11.536,-0l-1.073,4.056l-6.766,-0Zm12.577,0l-0.68,2.689l6.766,0l-1.071,4.252l-6.766,0l-0.678,2.687l6.766,-0l-1.073,4.253l-11.534,-0l4.572,-17.937l11.535,-0l-1.071,4.056l-6.766,-0Zm22.235,-4.056l-1.072,4.056l-4.215,0l-3.499,13.881l-4.769,0l3.5,-13.881l-4.471,0l1.072,-4.056l13.454,0Zm0.511,2.329c0.375,-1.485 1.712,-2.525 3.243,-2.525l6.556,0c2.177,0 3.774,2.048 3.242,4.16l-3.522,13.972l-4.77,0l1.071,-4.252l0.679,-2.687l-3.916,0l-0.677,2.687l-1.071,4.252l-4.77,0l3.936,-15.607l-0.001,0Zm7.57,4.416l0.678,-2.689l-3.916,0l-0.678,2.689l3.916,0Zm-62.945,20.44l1.99,-7.811l4.646,0l-0.271,1.024l-3.313,0l-0.574,2.274l3.308,0l-0.282,1.12l-3.308,0l-0.575,2.274l3.31,0l-0.282,1.119l-4.649,0Zm-5.147,-0l1.712,-6.787l-2.178,-0l0.27,-1.024l5.586,-0l-0.271,1.024l-2.065,-0l-1.711,6.787l-1.343,-0Zm15.767,0.028l0.374,-1.482l0.482,-1.911l-2.905,-0l-0.855,3.394l-1.342,-0l1.774,-7.034c0.129,-0.514 0.59,-0.873 1.12,-0.873l3.206,-0c0.358,-0 0.69,0.162 0.911,0.445c0.22,0.283 0.296,0.645 0.209,0.992l-1.631,6.47l-1.343,-0.001Zm-1.767,-4.513l2.905,0l0.573,-2.275l-2.905,0l-0.573,2.275Zm27.998,4.491l1.99,-7.81l4.644,0l-0.27,1.024l-3.313,0l-0.573,2.274l3.308,0l-0.282,1.119l-3.308,0l-0.575,2.274l3.309,0l-0.282,1.119l-4.648,0Zm10.608,0.029l0.373,-1.483l0.483,-1.911l-2.906,0l-0.854,3.394l-1.343,0l1.775,-7.034c0.129,-0.513 0.589,-0.873 1.12,-0.873l3.205,0c0.359,0 0.691,0.162 0.912,0.445c0.22,0.284 0.296,0.645 0.209,0.992l-1.631,6.47l-1.343,0Zm-1.767,-4.513l2.904,0l0.574,-2.274l-2.905,0l-0.573,2.274Zm-18.914,4.471c-0.359,0 -0.691,-0.162 -0.912,-0.445c-0.221,-0.283 -0.296,-0.645 -0.209,-0.992l1.63,-6.36l1.34,0l-1.711,6.678l2.905,0l1.712,-6.678l1.34,0l-1.711,6.678l2.905,0l1.711,-6.678l1.343,0l-1.992,7.797l-8.351,0Zm-4.519,0l1.711,-6.677l-2.905,0l-1.712,6.677l-1.341,0l1.712,-6.677l-2.905,0l-1.711,6.677l-1.343,0l1.991,-7.797l8.353,0c0.359,0 0.691,0.162 0.912,0.445c0.22,0.284 0.296,0.645 0.209,0.992l-1.63,6.36l-1.341,0Zm32.222,0.046l-0.227,-3.392l-1.654,0l-0.856,3.394l-1.342,0l1.23,-4.877l0.332,-1.314l0.433,-1.717l4.105,0c0.359,0 0.691,0.162 0.912,0.445c0.22,0.284 0.296,0.645 0.209,0.992l-0.557,2.202c-0.116,0.462 -0.512,0.809 -0.985,0.864l-0.455,0.053l0.224,3.35l-1.369,0Zm-1.6,-4.511l2.906,-0l0.573,-2.273l-2.904,-0l-0.575,2.273Z"
            :style="{
              fill: cheetaLogo.color.value,
              transition: 'all 500ms',
              fillRule: 'nonzero',
            }"
          />
        </g>
      </g>
    </g>
    <defs>
      <BackLogoImages :logos="{ backFullLogo, backUpperLogo }" :id="id" />

      <linearGradient
        :id="`linear${id}`"
        x1="0"
        y1="0"
        x2="1"
        y2="-2.29896e-05"
        gradientUnits="userSpaceOnUse"
        gradientTransform="matrix(0.803399,-74.9137,-228.664,-2.46832,-49.1485,124.287)"
      >
        <stop
          offset="0"
          :style="{
            stopColor: productColors.primary_2.value,
            stopOpacity: 1,
            transition: 'all 500ms',
          }"
        />
        <stop
          offset="0.79"
          :style="{
            stopColor: productColors.primary_1.value,
            stopOpacity: 1,
            transition: 'all 500ms',
          }"
        />
        <stop
          offset="1"
          :style="{
            stopColor: productColors.primary_1.value,
            stopOpacity: 1,
            transition: 'all 500ms',
          }"
        />
      </linearGradient>
      <svg:style>
        {{ fontFace }}
      </svg:style>
    </defs>
  </svg>
</template>

<script>
import { getFontFace } from "@/assets/fonts/fontsBase64";
import { computed } from "vue";
import BackLogoImages from "@/components/SVGImagesAsComponents/Common/BackLogoImages";
import BackPlayerNumber from "@/components/SVGImagesAsComponents/Common/BackPlayerNumber";
export default {
  name: "Singlet_6_back",
  components: { BackPlayerNumber, BackLogoImages },
  props: ["productColors", "logo", "activePlayer", "cheetaLogo", "details"],
  setup(props) {
    const id = Math.floor(Math.random() * 10000).toString();
    const fontFace = computed(() => getFontFace(props.details.fontFamily));

    const backFullLogo = computed(() => props.logo.backFull);
    const backCenterLogo = computed(() => props.logo.backCenter);
    const backUpperLogo = computed(() => props.logo.backUpper);

    return {
      id,
      fontFace,
      backFullLogo,
      backCenterLogo,
      backUpperLogo,
    };
  },
};
</script>
